import React from 'react';
import { lzBytesToSize } from '../../../../../services/LzUtils';
import MediaModel from '../../../../../models/media';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import LzToolbar from '../../../../commons/toolbar';

class MediaInfoComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    getActionIcons() {
        const { forSelection, record, onActionIconClick } = this.props;
        const media = new MediaModel(record);
        const out = [];

        if (onActionIconClick) {
            if (forSelection) {
                out.push({ label: 'Select Media', icon: <CheckIcon />, color: 'success', variant: 'contained', onClick: () => onActionIconClick('select', media) });
            } else {
                if (media.deleted_at) {
                    out.push({ label: 'Restore', icon: <RestoreFromTrashIcon />, color: 'success', variant: 'contained', onClick: () => onActionIconClick('deleted_restore', media) });
                    out.push({ label: 'Delete Forever', icon: <DeleteForeverIcon />, color: 'danger', variant: 'contained', onClick: () => onActionIconClick('deleted_purge', media) });
                } else {
                    if (media.is_active) {
                        out.push({ label: 'De-Activate', icon: <CloseIcon />, color: 'warning', variant: 'contained', onClick: () => onActionIconClick('status', media) });
                    } else {
                        out.push({ label: 'Activate', icon: <CheckIcon />, color: 'success', variant: 'contained', onClick: () => onActionIconClick('status', media) });
                    }
                    out.push({ label: 'Delete', icon: <DeleteIcon />, color: 'danger', variant: 'contained', onClick: () => onActionIconClick('delete', media) });
                }
            }
        }

        return out;
    }

    render() {
        const { record, onActionIconClick } = this.props;

        const media = new MediaModel(record);

        return (
            <Paper className="lz-paper-box" variant="outlined">
                <h2>Media Info</h2>
                {record ?
                    <React.Fragment>

                        <Typography variant="h5" color="secondary" style={{ textAlign: 'center' }}>{media.name}</Typography>

                        {media.isImage ?
                            <img src={media.file_preview_path} alt={media.name} style={{
                                display: 'block',
                                margin: '1em auto',
                                width: 'auto',
                                height: 'auto',
                                maxWidth: '100%',
                                maxHeight: 240,
                            }} />
                            :
                            <div style={{
                                margin: '1em 0',
                                height: 240,
                            }}>{media.contentTypeIcon}</div>
                        }

                        <Typography variant="subtitle1">Filename: <b>{media.file_name}</b></Typography>

                        <Typography variant="subtitle1">File Size: <b>{lzBytesToSize(media.file_size)}</b></Typography>

                        <Typography variant="subtitle1">Category: <b style={{ textTransform: 'capitalize' }}>{media.category}</b></Typography>

                        <Typography variant="subtitle1">Visibility: <b>{media.is_private ? 'Private' : 'Public'}</b></Typography>

                        <Typography variant="subtitle1">Status:
                            &nbsp;
                            <Chip size="small"
                                className={'status-chip ' + (media.deleted_at ? 'danger' : (media.is_active ? 'success' : 'warning'))}
                                label={media.deleted_at ? 'deleted' : (media.is_active ? 'active' : 'in-active')}
                            />
                        </Typography>

                        {onActionIconClick &&
                            <LzToolbar
                                items={this.getActionIcons()}
                            />
                        }

                    </React.Fragment>
                    :
                    <React.Fragment>
                        <Typography variant="overline" display="block" gutterBottom>
                            no media selected...
                        </Typography>
                    </React.Fragment>
                }
            </Paper>
        );
    }

}

export default MediaInfoComponent;
